import { SxProps, Theme } from "@mui/material/styles";

export function wrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1,
        width: "100%",
        borderRadius: "20px 20px 0 0",
        my: "24px",
        height: "calc(100vh - (84px * 1) - 2px - 48px)",
        maxHeight: "calc(100vh - (84px * 1) - 2px - 48px)",
    };
}

export function listCertificatesTitle(theme: Theme): SxProps<Theme> {
    return {
        margin: 0,
        paddingTop: "0.3em",
        paddingBottom: 0,
    };
}

export function titleWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#ececec",
    };
}

export function tableContainer(theme: Theme): SxProps<Theme> {
    return {
        overflow: "auto",
        maxHeight: `calc(100% - 48px - 0.3em)`,
        height: `calc(100% - 48px - 0.3em)`,
    };
}

export function tableSearch(theme: Theme): SxProps<Theme> {
    return {
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        marginTop: "0.50rem",
        paddingBottom: "0.50rem",
    };
}

export function tableTextField(theme: Theme): SxProps<Theme> {
    return {
        maxHeight: "40px",
        backgroundColor: "white",
        borderRadius: "5px",
        minWidth: "150px",
        maxWidth: "170px",
    };
}

export function statusFilter(theme: Theme): SxProps<Theme> {
    return {
        maxWidth: "125px",
        width: "125px",
        backgroundColor: "white",
        borderRadius: "5px",
    };
}
